
(function () {
  
    let bundle;

    function aetLog(str) {
        console.debug(str);
    }

    // analytics.subscribe('product_added_to_cart', (event) => {
    //   // Example for accessing event data
  
    // });


    document.addEventListener('rebuy:cart.add', (event) => { 
      console.log('rebuy:cart.add event', event.detail); 
    });
  
    document.addEventListener('rebuy:cart.change', (event) => { 
      console.log('rebuy:cart.change event', event.detail); 
      var subtotal = event.detail.cart.cart.items_subtotal_price;
      console.log(subtotal);
      console.log(event.detail.cart.cart.items);
      if (event.detail.cart.cart.items) {
        var filtered = event.detail.cart.cart.items.filter((el) => {
          console.log(el.properties);
          return el.properties && el.properties['_attribution'] === 'Rebuy Tiered Progress Bar'
        })

        if (filtered.length > 0 && subtotal >= 200) {
          fetch(`/discount/FREECS1`)
            .then(function () {

                // After the discount code has been applied, force the cart to update so the discount is visible instantly
                // return fetch('/cart/update.js', {
                //     method: 'POST',
                //     headers: {
                //         'Content-Type': 'application/json'
                //     },
                //     body: JSON.stringify({
                //         updates: {},
                //     }),
                // }).then(function () {
                   
                // });
            })
            .catch(function (error) {
                console.error('Error:', error);
                
            });
        }
      }
    });

    const handleError = function (err) {
        console.warn(err);
        return new Response(JSON.stringify({
            code: 400,
            message: 'Stupid network Error'
        }));
    };

    async function addToCart(data) {
        const response = await (fetch('/cart/add.js ', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(data)
        }).catch(handleError));
        const ret = await response.json();

        aetLog(ret);

        const response2 = await (fetch('/cart.js ', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(data)
        }).catch(handleError));
        const ret2 = await response2.json();

        console.log(ret2);
      
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));


        document.dispatchEvent(new CustomEvent('cartUpdate', {bubbles: true}));
      
        document.dispatchEvent(new CustomEvent('theme:cart:added', {bubbles: true}));
        document.dispatchEvent(new CustomEvent('theme:cart:add', {bubbles: true}));
      
      //   document.dispatchEvent(new CustomEvent('theme:cart:added', {
      //       detail: {
      //           cart: ret2,
      //       },
      //       bubbles: true,
      //   }));

      document.dispatchEvent(new CustomEvent('theme:cart:update', {
            detail: {
                id: ret2.items[0].id,
                quantity: ret2.items[0].quantity
            },
            bubbles: true,
        }));

      //   document.dispatchEvent(new CustomEvent('theme:cart:change', {
      //       detail: {
      //           cart: ret2,
      //       },
      //       bubbles: true,
      //   }));
        return ret;
    }

    async function handleBundleClick() {
        aetLog('handleBundleClick');
        document.getElementById('bundle_compose').classList.add('loading');

        const components = [];
        const properties = {};
        Array.from(document.querySelectorAll('#bundle_compose select')).forEach((v, i) => {
            if (v.value !== '') {
                components.push({
                    id: v.value,
                    qty: 1
                });
                const index = i + 1;
                properties[index + '. ' + v.options[v.selectedIndex].innerText] = '1';
                properties['_id' + index] = v.value;
            }
        });
        properties['_bundle_id'] = meta.product.id;
        aetLog(components);

        const data = {
            'bundle_id': meta.product.id,
            'components': components
        };
        const response = await (fetch('https://shopbiz.wearevisum.com/api/v1/bundles', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(data)
        }).catch(handleError));

        try {
            const ret = await response.json();
            aetLog(ret);
            if (typeof ret !== 'undefined'
                && typeof ret.variants[0].shopify_id !== 'undefined') {
                aetLog(ret.variants[0].shopify_id);
                const data = {
                    id: ret.variants[0].shopify_id,
                    qty: 1,
                    properties: properties
                };
                addToCart(data);
            }

        } catch (e) {
            console.error(e);
        }

        document.getElementById('bundle_compose').classList.remove('loading');
    }

    function handleBundleProductChange(e) {
        const elem = e.target;
        const idBundle = elem.name.replace('bundle_products[', '').replace(']', '');
        const idSel = elem.options[elem.selectedIndex].value;
        aetLog(bundle);
        const selectedProduct = bundle[parseInt(idBundle) - 1].expanded_products.filter((v) => v.shopify_id == idSel)[0];
        aetLog(selectedProduct);
      
      
        const bundleDesc = document.getElementsByClassName('comp_desc_' + idBundle);
        let child_container;
        if (bundleDesc.length === 0) {
            child_container = document.createElement("div");
            child_container.classList.add('comp_desc_' + idBundle);
			child_container.classList.add('clearfix');
            child_container.style = "min-height: 120px;";
          
        } else {
            child_container = document.getElementsByClassName('comp_desc_' + idBundle)[0];
        }

        child_container.innerHTML = '';

        const img = document.createElement("img");
        img.src = selectedProduct.img;
      img.style = "float:left;margin-left:5px;width:120px;";
        const node = document.createTextNode(selectedProduct.title);
        child_container.appendChild(img);
        child_container.appendChild(node);

        if (bundleDesc.length === 0) {
            elem.parentNode.insertBefore(child_container, elem.nextSibling);
        }
      
      
      
        const total = recaculateBundlePrice();
        const price = Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active
        }).format(total);
        aetLog(price);
        document.querySelectorAll('.price__regular .price-item.main-price ')[0].innerText = price;
    }

    function recaculateBundlePrice() {
        let total = 0;
        Array.from(document.getElementsByClassName('bundle_select')).forEach((v) => {
            const price = v.options[v.selectedIndex].getAttribute('data-price');
            total += parseFloat(price);
        });
        // const totalHtml = total > 0 ? Intl.NumberFormat(Shopify.locale, {
        //         style: 'currency',
        //         currency: Shopify.currency.active
        //     }).format(total):'';
        // if (totalHtml !== '') {
        //     document.querySelector('.price-item.main-price').innerHTML = totalHtml;
        // }

        return total;
    }

    async function loadBundle() {
        const response = await fetch('https://shopbiz.wearevisum.com/api/v1/bundles?product_id=' + meta.product.id);
        bundle = await response.json();

        aetLog(bundle);

        const element = document.getElementById("bundle_compose");
        const container = document.createElement("div");

        bundle.forEach((v) => {
            const child_container = document.createElement("div");

            const h3 = document.createElement("h4");
            const node = document.createTextNode(v.name);
            h3.appendChild(node);

            const para = document.createElement("p");
            const nodeDesc = document.createTextNode(v.description);
            para.appendChild(nodeDesc);

            const select = document.createElement("select");
            select.setAttribute("name", "bundle_products[" + v.id + "]");
            select.setAttribute("class", "bundle_select");

            if (v.has_empty_option === 1) {
                const option = document.createElement("option");
                option.setAttribute("value", "");
                option.setAttribute("data-price", 0.0);
                const nodeDesc = document.createTextNode("No " + v.name);
                option.appendChild(nodeDesc);

                select.appendChild(option);
            }

            v.expanded_products.forEach((p) => {
                const option = document.createElement("option");
                option.setAttribute("value", p.shopify_id);
                option.setAttribute("data-price", p.price);
                const nodeDesc = document.createTextNode(p.title + (p.price > 0 ? ' ($' + p.price + ')' : ''));
                option.appendChild(nodeDesc);

                select.appendChild(option);
            });
            select.addEventListener('change', handleBundleProductChange)

            child_container.appendChild(h3);
            child_container.appendChild(para);
            child_container.appendChild(select);

            container.appendChild(child_container);
        });

        const button = document.createElement("button");
        button.setAttribute("id", "btn_add_bundle");
        button.setAttribute("class", "atc-button product-form__submit button button--full-width button--margin-x main-product-atc");
        button.innerHTML = '<span class="main-atc__label button__label">\n' +
            '              \n' +
            '              <span class="main-atc__label__text">Add to cart\n' +
            '</span>\n' +
            '            </span>';
        button.addEventListener("click", handleBundleClick)

        container.appendChild(button);

        while (element.firstChild) {
            element.firstChild.remove();
        }
        element.appendChild(container);
      
        Array.from(document.getElementsByClassName('bundle_select')).forEach((select) => {
            if (select.value !== "") {
                const changeEvent = new Event('change');
                select.dispatchEvent(changeEvent);
            }
        });
      
        recaculateBundlePrice();
        // logs [{ name: 'Joker'}, { name: 'Batman' }]
    }

    // Below are example event listeners.  They listen for theme events that Pipeline
    // fires in order to make it easier for you to add customizations.

    // Keep your scripts inside this IIFE function call to avoid leaking your
    // variables into the global scope.

    if (document.getElementById('bundle_compose')) {
        aetLog('Loading Bundle');
        loadBundle();
    } else {
        aetLog('No element for bundle');
    }


    document.addEventListener('theme:variant:change', function (event) {
        // You might use something like this to write a pre-order feature or a
        // custom swatch feature.
        var variant = event.detail.variant;
        var container = event.target;
        if (variant) {
          
            // console.log('Container ———————— ↓');
            // console.log(container);
            // console.log('Variant —————————— ↓');
            // console.log(variant);
            // ... update some element on the page
        }
    });

    document.addEventListener('theme:cart:change', function (event) {
        var cart = event.detail.cart;
        if (cart) {
            console.log('Cart ———————————— ↓');
            console.log(cart);
            if (Rebuy && Rebuy.SmartCart) {
                Rebuy.Cart.setCart(cart);
    	        Rebuy.SmartCart.setCart(cart);
            }
	        
            // ... update an app or a custom shipping caluclator
        }
    });
    // Fired when page loads to update header values
    document.addEventListener('theme:cart:init', (e) => {
        console.log('theme:cart:init');
        // console.log(e);
    });

    // Debounced scroll listeners.  Up and down only fire on direction changes
    // These events are useful for creating sticky elements and popups.
    document.addEventListener('theme:scroll', e => {
        // console.log(e);
    });
    document.addEventListener('theme:scroll:up', e => {
        // console.log(e);
    });
    document.addEventListener('theme:scroll:down', e => {
        // console.log(e);
    });

    // Debounced resize listener to bundle changes that trigger document reflow
    document.addEventListener('theme:resize', e => {
        // console.log(e);
    });

    document.addEventListener("rebuy:cart.change", async function (event) {
        console.log("rebuy:cart.change event", event.detail);
        //refreshColorsAlertWidget();
        checkGidItems();

    });

if (document.querySelector('[value="44614034391176"] + div > button, [value="39852274319496"] + div > button')) {
    document.querySelector('[value="44614034391176"] + div > button, [value="39852274319496"] + div > button').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        var _gid = getGid();
        var _bonus = '100001';
        var widget_id_main = '900001';
        var widget_id = '900002';
        var bonus_items = [44650535649416, 44650546757768, 44650541678728];

        const items = [];

        // Get the variant ID from the clicked button's form
        const form = e.target.closest('form') || document.querySelector('form[action*="/cart/add"]');
        const variantInput = form ? form.querySelector('input[name="id"]') : null;
        const selectedVariantId = variantInput ? variantInput.value : '44614034391176';

        const obj1 = {
            quantity: 1,
            id: parseInt(selectedVariantId),
            properties: getProperties({
                _gid: _gid,
                _source: `pdp_offer`,
                _widget_id: widget_id_main,
            }),
        };
        items.push(obj1);
        
        for (const bonusItem of bonus_items) {
            const obj2 = {
                quantity: 1,
                id: bonusItem,
                properties: getProperties({
                    _gid: _gid,
                    _source: `pdp_offer`,
                    _bonus: _bonus,
                    _bonus_type: "GWPBonus",
                    _widget_id: widget_id,
                    _attribution: 'Rebuy Tiered Progress Bar',
                }),
            };
            items.push(obj2);
        }
        
        if (items.length > 0) {
            var data = {
                items: items,
            };
            
            fetch("/cart/add.js", {
                method: "POST",
                body: JSON.stringify(data),
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "xmlhttprequest",
                },
            })
            .then((response) => response.json())
            .then((resp) => {
                console.log('Items added to cart:', resp);
                
                // Fetch updated cart data
                return fetch('/cart.js', {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                });
            })
            .then((response) => response.json())
            .then((cart) => {
                console.log('Updated cart:', cart);
                
                // Trigger all cart update events
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('cartUpdate', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true }));
                
                // Update Rebuy if available
                if (window.Rebuy && window.Rebuy.SmartCart) {
                    Rebuy.Cart.setCart(cart);
                    Rebuy.SmartCart.setCart(cart);
                }
                
                document.dispatchEvent(new CustomEvent('theme:cart:change', {
                    detail: { cart: cart },
                    bubbles: true,
                }));
                
                // Small delay to ensure cart is fully updated before opening drawer
                setTimeout(() => {
                    document.querySelector('[href="/cart"]').click();
                }, 200);
            })
            .catch((error) => {
                console.error('Error adding to cart:', error);
                // Still try to open cart even if there's an error
                document.querySelector('[href="/cart"]').click();
            });
        }
    })
}


    // Locks and unlocks page scroll for modals and drawers
    // These are commented out because firing them will lock the page scroll
    // the lock event must set `detail` to the modal or drawer body so the
    // scroll locking code knows what element should maintain scoll.
    // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
    // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


    // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
    // variables into the global scope.
})();


function getGid() {
    const id = window.crypto.randomUUID();
    return id;
}

async function checkGidItems() {
    const cart = await getCart();
    if (!cart) {
        return;
    }

    // --- BEGIN group cart.items by _gid, remove groups missing final_price>0 ---
    // 1. Group items by _gid
    const gidGroups = {};
    for (const item of cart.items) {
        const gid = item.properties && item.properties._gid;
        if (!gid) continue;
        if (!gidGroups[gid]) gidGroups[gid] = [];
        gidGroups[gid].push(item);
    }

    // 2. For each group, check if any item has final_price > 0
    // 3. If no such item, remove all items with that _gid
    const gidsWithPositive = {};
    for (const gid in gidGroups) {
        if (gidGroups[gid].some(item => item.final_price > 0)) {
            gidsWithPositive[gid] = true;
        }
    }

    // 4. Filter cart.items: keep only items from groups without a product with final_price > 0
    const items_to_remove = cart.items.filter(item => {
        const gid = item.properties && item.properties._gid;
        if (!gid) return false;
        return !gidsWithPositive[gid];
    });

    // 5. Log the cleaned cart for debugging
    console.log("Cleaned cart.items:", items_to_remove);

    // Remove those items from the cart using Shopify's /cart/change.js endpoint
    if (items_to_remove.length > 0) {
        const changes = {};

        items_to_remove.forEach(item => {
            // Must use *line item key* (e.g. item.key) as the object key
            changes[item.key] = 0;
        });

        await fetch('/cart/update.js', {   // <-- Use update.js, not change.js
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ updates: changes })
        });

        console.log("Finished removing items from cart.");
    }
    // --- END group cart.items by _gid, remove groups missing final_price>0 ---

}

async function getCart() {
    const req = await fetch("/cart.js", {
        headers: {
            Accept: "application/json",
        },
    });

    return req.json();
}

function getProperties(obj) {
    return obj;
}

